/* eslint-disable prettier/prettier */
import { useState } from 'react';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Card } from 'antd';
import Illustration from '../assets/man-working.png';
import { UserService } from '../services/user.service';
import { CubeBackground } from '../components/shared/CubeBackground';

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState<{ email?: string }>({});
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors: typeof errors = {};
    if (!email) newErrors.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = 'Invalid email address';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await UserService.requestPasswordReset(email);
      setSuccessMessage(
        'We’ve sent you an email with a link to reset your password. If you don’t see it in your inbox, please check your spam or junk folder.',
      );
    } catch (err: any) {
      const message =
        typeof err?.response?.data?.message === 'string'
          ? err.response.data.message
          : err?.response?.data?.message?.message || 'An error occurred';
      setErrors({ email: message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen overflow-hidden bg-light">
      <CubeBackground />

      <Card className="w-full max-w-md py-5 px-10 flex flex-col items-center shadow-lg bg-white relative z-10 min-h-[380px]">
        <img src={Illustration} alt="Working Illustration" className="w-32 h-32 mx-auto mb-6" />
        <h2 className="mb-6 text-2xl font-bold text-center text-primary">Forgot Your Password?</h2>

        {successMessage && (
          <div className="p-3 mb-4 text-sm text-center text-green-700 border border-green-200 rounded bg-green-50">
            {successMessage}
          </div>
        )}

        <form className="w-full space-y-6 min-w-[360px]" onSubmit={handleSubmit}>
          <div>
            <Input
              className="w-full"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrors({});
              }}
              error={!!errors.email}
            />
            {errors.email && <p className="mt-1 text-sm text-red-500">{errors.email}</p>}
          </div>

          <div>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
};
